module.exports = __webpack_public_path__ + "static/media/slide5.bfbffe17.png";